'use strict';

/**
 * Style options for leaflet layers
 */

var _ = require('lodash');
var MarkerUtil = require('./MarkerUtil');

var MARKER_DEFAULTS = {
  icon: null,
};

var PATH_DEFAULTS = {
  fill: false,
  weight: 2,
  lineCap: 'square',
  lineJoin: 'square'
};

var Styles = {
  
  // route label specific styles
  label: {
    getIcon: MarkerUtil.getLabelIcon,
    default: {
      opacity: 1.0
    }
  },

  // route waypoint specific styles
  waypoint: {
    getIcon: MarkerUtil.getIcon,
    active: {
      iconOptions: {
        color: '#3A8ABF',
        iconColor: '#FFFFFF'
      },
      opacity: 1.0
    },
    default: {
      opacity: 1.0
    },
    dim: {
      opacity: 0.5
    }
  },

  // route path specific styles
  polyline: {
    active: _.extend({}, PATH_DEFAULTS, {
      opacity: 1
    }),
    default: PATH_DEFAULTS,
    dim: _.extend({}, PATH_DEFAULTS, {
      opacity: 1
    })
  },
};

module.exports = Styles;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/route/lib/LayerStyles.js